const deptReducer = (state = [], action) => {
  switch (action.type) {
    case 'SET_DEPT': {
      return action.payload
    }
    default:
      return state
  }
}
export default deptReducer